import { required } from 'vuelidate/lib/validators'
import validatorsByFields from '@/utils/validations/validatorsByFields'
import { slugAsyncValidator, slugValidator, validationErrorMessages } from '@/utils/validations/validations'
import historicalFiguresSlugsQuery from '@/services/gql/types/HistoricalFigures/queries/historicalFiguresSlugs.gql'
const { name } = validatorsByFields

export default ({ id, ctx, isNew }) => {
  const isUnique = async (value) => {
    return await slugAsyncValidator(value, id, historicalFiguresSlugsQuery, ctx, 'historicalFigures')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    name,
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: { validator: slugValidator, message: validationErrorMessages.slugGeneralMsg },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })()
  }
}
